import type { ReactNode } from "react";

/* ──────────────────────────────────────────────────────────────────────────
   The head of every panel on Now (Jay, 2026-10-08): a pink label, a white
   title, a grey line under it, then the divider. Always all three, one line
   each, so panels side by side have heads of exactly the same height.
   ────────────────────────────────────────────────────────────────────────── */

export function NowPanelHead({ label, icon, title, sub, side }: { label: ReactNode; icon?: ReactNode; title: ReactNode; sub: ReactNode; side?: ReactNode }) {
  return (
    <div className="panel-head signet-panel-head">
      <div className="signet-panel-head-text">
        <span className="signet-panel-label">
          {icon}
          {label}
        </span>
        <h2>{title}</h2>
        <p>{sub}</p>
      </div>
      {side ? <div className="signet-panel-head-side">{side}</div> : null}
    </div>
  );
}
